import { render } from "./AuthorConfirm.vue?vue&type=template&id=6c3bd24c&scoped=true&ts=true"
import script from "./AuthorConfirm.vue?vue&type=script&lang=ts"
export * from "./AuthorConfirm.vue?vue&type=script&lang=ts"

import "./AuthorConfirm.vue?vue&type=style&index=0&id=6c3bd24c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2791644585/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3bd24c"]])

export default __exports__